let _model;
export const scenes = {};

export const setModel = (model) => {
  _model = model;
}
export const getSceneDictionary = (sceneArray) => {
  const scenes = {};
  sceneArray.forEach(scene => {
    scenes[scene.id] = scene
  });
  return scenes;
};

export const setScenesThatCanBeLocked = (sceneArray) => {
  const locked = {};
  sceneArray.forEach((scene, index) => {
    if (index !== 0) {
      locked[scene.id] = scene
    }
  });
  return locked;
};

export const getSceneId = (socketuser, modelScenes) => {
  return socketuser.currentSceneId ? socketuser.currentSceneId : modelScenes[0].id;
}

export const getSceneName = (socketuser, modelScenes) => {
  return socketuser.currentSceneName ? socketuser.currentSceneName : modelScenes[0].name;
}

export const areInSameScene = (socketuser, currentUser, scenes) => {
  if (!socketuser || !currentUser) {
    return false;
  }
  let scene1id = socketuser.currentSceneId ? socketuser.currentSceneId : scenes[0].id;
  let scene2id = currentUser.currentSceneId ? currentUser.currentSceneId : scenes[0].id;
  return scene1id === scene2id;
}
export const areInSameSceneId = (socketuser, currentUser) => {
  if (!socketuser || !currentUser) {
    return false;
  }
  return socketuser.currentSceneId === currentUser.currentSceneId;
}

export const getSceneNameFromId = (socketuser, model = _model) => {
  const { currentSceneId } = socketuser;
  const id = currentSceneId || getSceneId(socketuser, model.sceneData.scenes);
  if (id === 'EDITOR') {
    return $trans('editor-text');
  }
  if (!model.scenes[id]) {
    console.log('user is from another space');
    return socketuser.currentSceneName || 'Limbus'
  } else {
    return model.scenes[id].name;
  }
}

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
};

export const makeId = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const randomIntFromInterval = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export const areInSameWorld = (user1, user2) => {
  return Number(user1.worldId) === Number(user2.worldId);
}

export const userShareScene = (user1, user2) => {
  return user1.currentSceneId === user2.currentSceneId;
}

/**
 * Resizes values in same porportions
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @param {number} minScale
 * @param {number} maxScale
 * @returns
 */
export const resizedValue = (value, minValue = 1, maxValue = 1.5, minScale, maxScale) => {
  // Ensure that value is within bounds
  value = Math.max(minValue, Math.min(value, maxValue));
  // Interpolate scale based on the value within the min and max range
  const scale = minScale + (maxScale - minScale) * ((value - minValue) / (maxValue - minValue));
  return scale;
}



export const findOccupiedItems = (items, type) => {
  // Filter the items of the given type where item.state.me is true
  return items[type].filter(item => item.state.me);
}

export const convertDateToUnixTimestamp = (timestampStr) => {
  // Create a Date object from the timestamp string
  var date = new Date(timestampStr);
  // Get the Unix timestamp in milliseconds
  var unixTimestampMs = date.getTime();
  return unixTimestampMs;
}

export const addTimeFromTimestamp = (chatData) => {
  if (chatData.timestamp) {
    chatData.time = convertDateToUnixTimestamp(chatData.timestamp);
  }
  return chatData;
}

export const radians = (degrees) => {
  return (degrees * Math.PI) / 180;
};

export const normalizeBetween = (val, min, max) => {
  return (val - min) / (max - min);
};




export const waitForSrcObject = (videoElement, timeout = 14000) => {
  return new Promise((resolve, reject) => {
    if (videoElement.srcObject) {
      resolve(videoElement.srcObject);
      return;
    }

    const interval = 100; // Check every 100 ms
    let elapsed = 0;

    const checkSrcObject = setInterval(() => {
      if (videoElement.srcObject) {
        clearInterval(checkSrcObject);
        resolve(videoElement.srcObject);
      } else if (elapsed > timeout) {
        clearInterval(checkSrcObject);
        reject(new Error('Timeout waiting for srcObject'));
      }

      elapsed += interval;
    }, interval);
  });
}
